// extracted by mini-css-extract-plugin
module.exports = {"container":"EditFolder_container__29sck","file":"EditFolder_file__2_d03","link":"EditFolder_link__2339-","delete":"EditFolder_delete__2fNso"};